import { Node, mergeAttributes } from '@tiptap/core'

/**
 * Node customizado para preservar DIVs com conteúdo HTML complexo
 * Preserva a estrutura HTML interna sem normalização
 */
export const CustomDivNode = Node.create({
    name: 'customDiv',
    group: 'block',
    atom: true,

    addAttributes() {
        return {
            htmlContent: {
                default: '',
                parseHTML: element => element.outerHTML,
                renderHTML: () => ({}),
            },
        }
    },

    parseHTML() {
        return [{
            tag: 'div',
            getAttrs: element => {
                // Captura o HTML completo do elemento
                return {
                    htmlContent: element.outerHTML,
                }
            },
        }];
    },

    renderHTML({ node }) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(node.attrs.htmlContent || '<div></div>', 'text/html');
        return doc.body.firstChild;
    },

    // Adiciona uma view personalizada para renderizar o HTML preservado
    addNodeView() {
        return ({ node }) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(node.attrs.htmlContent || '<div></div>', 'text/html');
            const dom = doc.body.firstChild;

            return {
                dom,
                contentDOM: null, // Não permite edição do conteúdo
            };
        };
    },
});